import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import { R } from '@core/utils/r';
import { TimeInput, toMoment } from '@core/utils/time';
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import React, { Fragment, useCallback, useMemo, useState } from 'react';
import { DateRangePicker, FocusedInputShape, SingleDatePickerShape } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { FormGroup, Label } from 'reactstrap';

export interface FormDateRangeInputProps extends FieldProps<FormControl<string> | FormControl<string | null>> {
  options?: SingleDatePickerShape;
  minDate?: TimeInput;
  maxDate?: TimeInput;
  onChange?(range: string): void;
  appendToBody?: boolean;
  anchorDirection?: 'left' | 'right';
  withoutGroup?: boolean;
  small?: boolean;
}

export function FormDateRange(props: FormDateRangeInputProps) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldValue = fieldState.value;
  const sStart = R.toNumber(R.toString(fieldValue).split('-')[0]);
  const sEnd = R.toNumber(R.toString(fieldValue).split('-')[1]);

  const startDate = useMemo(() => {
    if (sStart) {
      return toMoment(sStart).startOf('day');
    } else {
      return toMoment().subtract(30, 'day').startOf('day');
    }
  }, [sStart]);
  const endDate = useMemo(() => {
    if (sEnd) {
      return toMoment(sEnd).endOf('day');
    } else {
      return toMoment().endOf('day');
    }
  }, [sEnd]);

  //   const [startDate, setStartDate] = useState<moment.Moment | null>(sStart ? toMoment(sStart) : moment().subtract(30, 'day'));
  //   const [endDate, setEndDate] = useState<moment.Moment | null>(eEnd ? toMoment(eEnd) : moment().add(0, 'day'));
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);

  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;

  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldReadonly = fieldConfig.readonly || false;
  const fieldDisabled = fieldConfig.disabled || false;

  const fieldPlaceholder = fieldConfig.placeholder || 'mm/dd/yyyy';

  const handleChange = useCallback(
    (startDate: moment.Moment | null, endDate: moment.Moment | null) => {
      //   if (startDate) {
      //     setStartDate(startDate.startOf('day'));
      //   }
      //   if (endDate) {
      //     setEndDate(endDate.endOf('day'));
      //   }
      const fieldValue = `${startDate?.startOf('day').unix()}-${endDate?.endOf('day').unix()}`;
      formControl.setValue(fieldValue);
      props.onChange && props.onChange(fieldValue);
    },
    [formControl, props],
  );

  const content = (
    <Fragment>
      {fieldConfig.label && (
        <>
          <Label for={formControl.uid}>{fieldConfig.label}</Label> <br />
        </>
      )}

      <DateRangePicker
        small={props.small}
        startDate={startDate}
        startDateId={`${formControl.uid}-start`}
        endDate={endDate}
        endDateId={`${formControl.uid}-end`}
        onDatesChange={({ startDate, endDate }) => handleChange(startDate, endDate)}
        focusedInput={focusedInput}
        onFocusChange={focusedInput => setFocusedInput(focusedInput)}
        isOutsideRange={() => false}
        readOnly={fieldReadonly}
        disabled={fieldDisabled}
        startDatePlaceholderText={fieldPlaceholder}
        endDatePlaceholderText={fieldPlaceholder}
        appendToBody={props.appendToBody}
        minimumNights={0}
      />
      {!!fieldError && <FormHelperText style={{ color: '#f44336' }}>{fieldError}</FormHelperText>}
    </Fragment>
  );

  if (props.withoutGroup) {
    return <div className="theme_date-picker">{content}</div>;
  }

  return <FormGroup className="theme_date-picker">{content}</FormGroup>;
}
